export const numberPattern = `^[0-9]+$`;
export const namePattern = `^[a-zA-Z0-9 &'-@]+$`;